export default {
    isProfileLoading: false,
    profileErrorMessage: null,
    userProfile: null
}